import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import apiClient from '../services/api';
import { Loader, Crown, Lock } from 'lucide-react';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading: authLoading } = useAuth();
  const location = useLocation();
  const [subscriptionStatus, setSubscriptionStatus] = useState(null);
  const [checkingSubscription, setCheckingSubscription] = useState(true);

  useEffect(() => {
    if (isAuthenticated) {
      checkSubscription();
    } else {
      setCheckingSubscription(false);
    }
  }, [isAuthenticated]);

  const checkSubscription = async () => {
    try {
      const response = await apiClient.get('/subscription/status');
      setSubscriptionStatus(response.data);
    } catch (error) {
      console.error('Failed to check subscription:', error);
      setSubscriptionStatus({ is_subscribed: false });
    } finally {
      setCheckingSubscription(false);
    }
  };

  if (authLoading || checkingSubscription) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-green-50 via-white to-red-50">
        <div className="text-center">
          <Loader className="w-12 h-12 animate-spin text-green-600 mx-auto mb-4" />
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  if (!subscriptionStatus?.is_subscribed) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-green-50 via-white to-red-50 px-4">
        <div className="max-w-md w-full">
          <div className="text-center mb-8">
            <div className="relative inline-block mb-4">
              <Crown className="w-20 h-20 text-gray-300" />
              <Lock className="w-8 h-8 text-red-500 absolute -bottom-1 -right-1 bg-white rounded-full p-1" />
            </div>
            <h2 className="text-2xl font-bold text-gray-900 font-heading mb-2">
              Subscription Required
            </h2>
            <p className="text-gray-600">
              Subscribe to access all vocabulary, games, and features
            </p>
          </div>
          
          <div className="space-y-3">
            <button
              onClick={() => window.location.href = '/pricing'}
              className="w-full py-3 px-4 bg-gradient-to-r from-green-600 to-red-600 hover:from-green-700 hover:to-red-700 text-white font-semibold rounded-lg transition-all"
            >
              View Pricing & Subscribe
            </button>
            <button
              onClick={() => window.location.href = '/'}
              className="w-full py-3 px-4 border border-gray-300 hover:bg-gray-50 text-gray-700 font-semibold rounded-lg transition-all"
            >
              Back to Home
            </button>
          </div>
        </div>
      </div>
    );
  }

  return children;
};

export default ProtectedRoute;
